import { subMonths } from 'date-fns'

import type { DefaultOption } from 'common/components/dateRange/interfaces'

export const options: DefaultOption[] = [
  {
    id: '3-months',
    title: '3M',
    start: subMonths(new Date(), 3),
    end: new Date(),
  },
  {
    id: '6-months',
    title: '6M',
    start: subMonths(new Date(), 6),
    end: new Date(),
  },
  {
    id: '12-months',
    title: '12M',
    start: subMonths(new Date(), 12),
    end: new Date(),
  },
]
